<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem><b>1号AI > 智能体框架</b></BreadcrumbItem>
      </Breadcrumb>
      <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
	  		<span class="search_span_width" style="margin-right: 10px;">
	  				<span class="search_span_width_part1">ID：</span>
	  				<Input v-model="search.id"  style="width: 100px" />
        </span>
        <span class="search_span_width">
          <span class="search_span_width_part1">用户：</span>
          <Select
              v-model="search.user_id"
              filterable
              :remote-method="userList"
              :loading="loading3"  clearable style="width: 180px">
            <Option v-for="(option, index) in user_list" :value="option.id" :key="index">{{option.nickname}}</Option>
          </Select>
	      </span>


        <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getList(1)">搜索</Button>
      </Card>
      <Card id="tableContent" >
        <Table :columns="tableColumns" :data="data_list"></Table>
        <Page :total="total" :current="search.page" :page-size=search.pagesize :show-elevator="true" @on-change="getList"/>
      </Card>
    </Content>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      total:20,
      search:{
        page:1,
        pagesize:15
      },
      user_list:[],
      loading3: false,
      data_list:[],
      tableColumns:[
        { title: 'ID', key: 'id', align: 'center',width: 150 },
        { title: '用户', key: 'nickname', align: 'center' },
        { title: '角色ID', key: 'role_id', align: 'center' },
        { title: '选题类型', key: 'topic_type', align: 'center' },
        { title: '选题方向', key: 'topic_subject', align: 'center' },
        { title: '创建时间', key: 'created_at', align: 'center' },
        { title: '更新时间', key: 'updated_at', align: 'center' }
      ]
    }
  },
  mounted:function(){
    this.getList()
  },
  computed:{
  },
  methods:{
    getList(page){
      if(page){
        this.search.page = page
      }
      this.http.get('/admin/hotspot/getFrameList',{params:this.search}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.data_list = data.data.list;
          this.total = data.data.total
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    userList(query){
      if (query !== '' && query.length >=2) {
        this.loading3 = true;
        setTimeout(() => {
          this.loading3 = false;

          this.http1.get('/user/getUserSelectAll',{params:{nickname:query}}).then(response=>{
            let data=response.data;
            if(data.code!==0)
            {
              alert(data.message);
            } else{
              this.user_list = data.data;
            }
          }).catch(()=>{
            this.$Message.error('网络错误');
          });

        }, 200);
      }
    },
  }

}
</script>
